const constants = {
  termsVersion: 2,
  avatars: ['1.png', '2.png', '3.png', '4.png', '5.png', '6.png', '7.png', '8.png'],
  defaultPrimaryColour: '#819df8',

  businessSectors: [
    'Agriculture and Farming',
    'Consumer Products and Retail',
    'Creative Industries',
    'Education, Recruitment and Training',
    'Environmental and Energy',
    'Financial and Professional Services',
    'Food and Hospitality',
    'I.C.T.',
    'Life Sciences',
    'Manufacturing, Advanced Materials and Engineering',
    'Property and Construction',
    'Sport, Leisure and Tourism',
    'Other',
  ],

  organisationCategories: [
    'Accountancy, banking and finance',
    'Business, consulting and management',
    'Charity and voluntary work',
    'Creative arts and design',
    'Energy and utilities',
    'Engineering and manufacturing',
    'Environment and agriculture',
    'Healthcare',
    'Hospitality and events management',
    'Information technology',
    'Law',
    'Law enforcement and security',
    'Leisure, sport and tourism',
    'Marketing, advertising and PR',
    'Media and internet',
    'Property and construction',
    'Public services and administration',
    'Recruitment and HR',
    'Retail',
    'Sales',
    'Science and pharmaceuticals',
    'Social care',
    'Teacher training and education',
    'Transport and logistics',
  ],

  supplierInnovationTags: [
    'Aerospace and Defence',
    'Agriculture, Forestry and Paper',
    'Automotive: Vehicle and Parts',
    'Banks and insurance',
    'Chemicals',
    'Construction and Materials',
    'Electronics and Electrical Equipment',
    'Food and Beverage',
    'Healthcare',
    'Industrial and General Engineering',
    'Industrial Goods and Services',
    'Industrial Metals',
    'Media',
    'Mining',
    'Oil and Gas',
    'Personal and Household Goods',
    'Pharmaceuticals and Biotechnology',
    'Retail',
    'Technology – Hardware & Software',
    'Telecommunications',
    'Transportation',
    'Travel, Leisure and Leisure Goods',
    'Utilities',
    'Other',
  ],

  employeeImprovementTags: [
    'Business Continuity',
    'CPD',
    'Charity and Voluntary',
    'Diversity and Inclusion',
    'Equipment',
    'Estates and Facilities',
    'External Communications',
    'Finance',
    'Health and Safety',
    'Internal Communications',
    'Leadership and Organisational Development',
    'User Experience',
    'Quality Improvement',
    'Recognition and Awards',
    'Sustainability',
  ],

  businessExperiences: [
    'Work experience',
    'Summer placements',
    'Year long placements',
    'Internships (paid)',
    'Internships (unpaid)',
  ],

  fileTypeIcons: {
    'archive outline': ['zip', 'gz', 'tar'],
    'word outline': ['doc', 'docx'],
    'code outline': ['js', 'python', 'c', 'java', 'json', 'xml', 'html', 'css', 'md'],
    'image outline': ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
    'pdf outline': ['pdf'],
    'video outline': ['mp4', 'mkv', 'wmv', 'm4'],
    'powerpoint outline': ['ppt', 'pptx'],
    'audio outline': ['wav', 'mp3', 'ogg'],
    'excel outline': ['xls', 'xlsx'],
    'text outline': ['txt'],
  },

  permissions: {
    super: [
      { key: 'super.viewDashboard', title: 'View dashboard', text: 'Enable the superadmin dashboard for this user. This shows/hides the \'Superadmin\' link in the header.' },
      { key: 'super.listOrgs', title: 'List organisations', text: 'Allow the user to view a list of existing organisations.' },
      { key: 'super.createOrgs', title: 'Create organisations', text: 'Allow the user to create new organisations.' },
      { key: 'super.manageOrgs', title: 'Manage organisations', text: 'Allow editing existing organisations.' },
      { key: 'super.deleteOrgs', title: 'Delete organisations', text: 'Allow the user to delete existing organisations.' },
      { key: 'super.ghost', title: 'Ghosting', text: 'Allow the user to ghost into existing organisations.' },
      { key: 'super.listRecents', title: 'View recently online', text: 'Allow the user to view recently online users across all organisations.' },
      { key: 'super.managePermissions', title: 'Manage permissions', text: 'Allow the user to manage super-level user permissions.' },
    ],
    org: [
      { key: 'org.viewDashboard', title: 'View admin dashboard', text: 'Enable the admin organisation dashboard for this user. This shows/hides the \'Administration\' link in the header.' },
      { key: 'org.listUsers', title: 'View user list', text: 'Allow viewing the list of users registered with your organisation. Depends on org.viewDashboard.' },
      { key: 'org.deleteUsers', title: 'Delete users', text: 'Allow deletion of registered users. Depends on org.viewDashboard and org.listUsers.' },
      { key: 'org.uploadFiles', title: 'Upload files', text: 'Allow user to upload new files (and to delete their own files) in Uploads Area. Depends on org.viewDashboard.' },
      { key: 'org.deleteFiles', title: 'Delete files', text: 'Allow user to delete all files in Uploads Area. Depends on org.viewDashboard and org.uploadFiles.' },
      { key: 'org.createGroups', title: 'Create groups', text: 'Allow user to create new groups (and become their leader).' },
      { key: 'org.manageGroups', title: 'Manage groups', text: 'Allow user to manage all groups as if they were the group leader.' },
      { key: 'org.deleteGroups', title: 'Delete groups', text: 'Allow user to delete all groups.' },
      { key: 'org.createChallenges', title: 'Create challenges', text: 'Allow user to create and edit their own challenges (if restricted in organisation settings).' },
      { key: 'org.manageChallenges', title: 'Manage challenges', text: 'Allow user to track and edit all challenges posted by users in your organisation. Depends on org.viewDashboard' },
      { key: 'org.publishChallenges', title: 'Publish challenges', text: 'Allow user to publish and close challenges in your organisation' },
      { key: 'org.deleteChallenges', title: 'Delete challenges', text: 'Allow the user to delete challenges posted by users in your organisation. Depends on org.viewDashboard and org.manageChallenges' },
      { key: 'org.manageProjectBoards', title: 'Manage project boards', text: 'Allow the user to create and manage project boards in their organisation.' },
      { key: 'org.createAnnouncements', title: 'Create announcements', text: 'Allow the user to create and manage their own announcements. Depends on org.viewDashboard.' },
      { key: 'org.manageAnnouncements', title: 'Manage announcements', text: 'Allow the user to manage and delete all announcements. Depends on org.viewDashboard and org.createAnnouncements.' },
      { key: 'org.changeSettings', title: 'Change settings', text: 'Allow the user to change core organisaion settings (e.g. branding, sign-on, and security). Depends on org.viewDashboard.' },
      { key: 'org.managePermissions', title: 'Manage user permissions', text: 'Allow the user to manage organisation-level user permissions. Depends on org.viewDashboard and org.listUsers and org.manageUsers.' },
      { key: 'org.innovationIntelligence', title: 'Innovation intelligence', text: 'Allow the user to access the innovation intelligence area, in any group in their organisation.' },
      { key: 'org.ipManagement', title: 'IP Management', text: 'Allow the user to sign IP statements for challenges in this organisation, on behalf of the organisation.' },
      { key: 'org.viewEdi', title: 'View EDI', text: 'Allow the user to view data contained in EDI sections in ideas.' },
    ],
    group: [
      { key: 'group.leader', title: 'Group Leader', text: 'Administrate group, including changing settings and members.' },
    ],
  },
  legacyStampMapper: {
    green_apple: 'green',
    full_moon: 'yellow',
    large_orange_diamond: 'orange',
    red_circle: 'red',
    aquarius: 'purple',
    large_blue_circle: 'blue',
    ribbon: 'pink',
    green: 'green_apple',
    yellow: 'full_moon',
    orange: 'large_orange_diamond',
    red: 'red_circle',
    purple: 'aquarius',
    blue: 'large_blue_circle',
    pink: 'ribbon',
  },
  subscriptions: [
    {
      type: 'general',
      title: 'Direct messages',
      key: 'directMessages',
      text: 'Someone sends me a direct message.',
    },
    {
      type: 'general',
      title: 'Announcements',
      key: 'announcements',
      text: 'I receive an announcement from an administrator.',
    },
    {
      type: 'general',
      title: 'Invitations',
      key: 'invitations',
      text: 'Someone sends me an invitation to a group, idea team etc',
    },
    {
      type: 'general',
      title: 'Mentions and replies',
      key: 'userInteraction',
      text: 'Someone replies or reacts to one of my posts or a post I am mentioned in.',
    },
    {
      type: 'general',
      title: 'Achievements',
      key: 'achievements',
      text: 'I unlock a new achievement.',
    },
    {
      type: 'ideas',
      title: 'Idea updates',
      key: 'ideaUpdates',
      text: 'Someone comments on or votes for one of my ideas, or an idea I follow.',
    },
    {
      type: 'ideas',
      title: 'Idea progression',
      key: 'ideaManagement',
      text: 'There has been an update to one of my ideas or an idea I am assigned to.',
    },
    {
      type: 'challenges',
      title: 'Challenge updates',
      key: 'challengeUpdates',
      text: 'A challenge matching my interests is now open to receive ideas or about to close.',
    },
    {
      type: 'challenges',
      title: 'Submissions and assessments',
      key: 'challengeManagement',
      text: 'An idea or assessment is submitted to a challenge I own or manage.',
    },
    {
      type: 'challenges',
      title: 'Daily activity updates',
      key: 'challengeDailyUpdates',
      text: 'Daily email updates about my published challenges.',
    },
    {
      type: 'challenges',
      title: 'Weekly activity updates',
      key: 'challengeWeeklyUpdates',
      text: 'Weekly email updates about my published challenges.',
    },
    {
      type: 'groups',
      title: 'Group discussions',
      key: 'groupDiscussions',
      text: 'Someone posts in the discussion of a group I am a member of.',
    },
    {
      type: 'ideas',
      title: 'Weekly followed idea updates',
      key: 'followedIdeaWeeklyUpdates',
      text: 'Weekly email updates about activity, including ideas and comments, for ideas you follow.',
    },
  ],

  enabledFeatures: ([
    {
      key: 'challenges',
      title: 'Create challenges',
    },
    {
      key: 'createExternalChallenges',
      title: 'Create external challenges',
    },
    {
      key: 'receiveExternalChallenges',
      title: 'Receive external challenges',
    },
    {
      key: 'receiveReferrals',
      title: 'Receive user referred from another organisation',
    },
    {
      key: 'disableIntercom',
      title: 'Disable Intercom',
    },
    {
      key: 'videoCall',
      title: 'Allow users to video call other direct message users',
    },
    {
      key: 'innovationIntelligence',
      title: 'Innovation intelligence, including horizon scanning and dashboards',
    },
    {
      key: 'innovationIntelligenceLocalSearch',
      title: 'Innovation intelligence (Local Search EXPERIMENTAL)',
    },
    {
      key: 'ipManagement',
      title: 'Challenge IP management, including signing and blockchain',
    },
    {
      key: 'ideaImpacts',
      title: 'Idea impact measures',
    },
    {
      key: 'globalCreditsafe',
      title: 'Use SimplyDo\'s Creditsafe login',
    },
    {
      key: 'simplyCrm',
      title: 'Enable Simply CRM integration',
    },
    {
      key: 'ideaBusinessProfiles',
      title: 'Enable idea business profiles',
    },
    {
      key: 'openAI',
      title: 'Open AI features',
    },
    {
      key: '6cs',
      title: 'Enable 6Cs challenges',
    },
    {
      key: 'allowPublicChallenges',
      title: 'Allow public challenges',
    },
    {
      key: 'useNewRoles',
      title: 'Use new roles system',
    },
    {
      key: 'ideaSpreadsheetView',
      title: 'Enable idea spreadsheet view',
    },
    {
      key: 'userGhosting',
      title: 'Enable user ghosting (Superadmins can always ghost)',
    },
    {
      key: 'ideaMerging',
      title: '[Experimental] Enable idea merging',
    },
  ] as const),
  superadminTags: [
    {
      key: 'internalInnovation',
      title: 'Employee led',
    },
    {
      key: 'externalInnovation',
      title: 'Supplier led',
    },
    {
      key: 'police',
      title: 'Police',
    },
    {
      key: 'nhs',
      title: 'NHS',
    },
  ],

  emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // eslint-disable-line no-useless-escape

  defaultSubscriptions: {
    announcements: ['email'],
    directMessages: ['email', 'push'],
    invitations: ['email'],
    mentions: ['email', 'push'],
    userInteraction: ['email', 'push'],
    achievements: ['push'],
    challengeUpdates: ['email', 'push'],
    challengeManagement: ['email', 'push'],
    ideaUpdates: ['email', 'push'],
    ideaManagement: ['email', 'push'],
    challengeDailyUpdates: [],
    challengeWeeklyUpdates: ['email', 'push'],
    groupDiscussions: ['push'],
  },

  productTours: [
    // Tour info:
    // - After adding a tour, ensure its enabled in the settings for organisation
    /*
    {
      key: 'example',
      value: 'example',
      title: 'Example title', // This is displayed to admins when enabling/disabling the tour
      description: 'Explain to users what a challenge is, and show where they can create an idea', // Same as above
      steps: [ // Any number of steps can be provided
        {
          target: '.challenge-tour-step-1', // CSS classname of the element to show the tooltip over
          content: 'This is the challenge header', // The content of the tooltip. This can be a string OR any react node
          disableBeacon: true, // 99% of the time you want to set disableBeacon: true - this ensures the tooltip automatically opens without user input,
          //
          // The following custom parameters are added to allow custom actions to take place.
          // If you provide a prop `customFunctions` to the ProductTour function, which is an object which keys as functionIds, then by specifing the functionId here they be called when that step is run _before_ any content is shown
          //
          customTourFunctionId: 'functionIdHere'
        },
      ],
    }
    */
    // {
    //   key: 'challenge',
    //   value: 'challenge',
    //   title: 'Challenge',
    //   description: 'Explain to users what a challenge is, and show where they can create an idea.',
    //   steps: [
    //     {
    //       target: '.challenge-tour-step-1',
    //       content: 'This is the challenge header',
    //       disableBeacon: true,
    //     },
    //     {
    //       target: '.challenge-tour-step-2',
    //       content: 'This is the challenge description',
    //       disableBeacon: true,
    //     },
    //     {
    //       target: '.challenge-tour-step-3',
    //       content: 'This is where you make a new idea',
    //       disableBeacon: true,
    //     },
    //   ],
    // },
    {
      key: 'assessment',
      value: 'assessment',
      title: 'Assessment',
      description: 'Explain what idea assessment is, and what actions the user must undertake.',
      steps: [
        {
          target: '.assessment-tour-step-1',
          content: 'Welcome to your assessments.\nThese are the ideas you have been assigned to assess.',
          disableBeacon: true,
          customTourFunctionId: 'closeIdea',
        },
        {
          target: '.assessment-tour-step-2',
          content: 'Each idea is assigned a total score based on your assessment.\nOnce you\'ve finished your assessment, you must submit it to finish the assessment.',
          disableBeacon: true,
        },
        {
          target: '.assessment-tour-step-5',
          content: 'The deadline for completing your assessments is shown here, please ensure you complete and submit your assessments before the deadline is reached.',
          disableBeacon: true,
        },
        {
          target: '.assessment-tour-step-3',
          content: 'Lets take a look at an assessment.',
          disableBeacon: true,
        },
        {
          placement: 'center',
          content: 'Take some time to read through the content of the idea you are assessing, then you can begin your assessment.',
          target: 'body',
          disableBeacon: true,
          customTourFunctionId: 'openIdea',
        },
        {
          target: '.assessment-tour-step-4',
          content: 'This is an assessment box, please fill in each of these with your assessment score and notes for each section.',
          disableBeacon: true,
        },
        {
          target: '.assessment-tour-step-6',
          content: 'Finally, once you have completed all of your assessments you can bulk submit them here.',
          customTourFunctionId: 'closeIdea',
          disableBeacon: true,
        },
      ],
    },
    {
      key: 'assessmentHomepage',
      value: 'assessmentHomepage',
      title: 'Assessment (Homepage)',
      description: 'Extension of the assessment tour that begins on the user\s homepage, directing them to their assignments from there.',
      steps: [
        {
          placement: 'center',
          target: 'body',
          content: 'Welcome to SimplyDo, thanks for signing up as an assessor. Let\'s take a look at how you can access your assessments.',
          disableBeacon: true,
        },
        {
          target: '.assessment-homepage-tour-step-1',
          content: 'These are your assignments. They are listed on your homepage for easy access. Assignments are grouped by challenge, with an indicator of how many you have to complete.',
          disableBeacon: true,
        },
        {
          target: '.assessment-homepage-tour-step-2',
          content: 'Click on a challenge to view it and learn more about your assignments.',
          disableBeacon: true,
        },
      ],
    },
    {
      key: 'innovationIntelligenceOverview',
      value: 'innovationIntelligenceOverview',
      title: 'Innovation Intelligence (Overview)',
      description: 'Explain what innovation intelligence is, and what actions the user can perform at a glance.',
      steps: [
        {
          placement: 'center',
          target: 'body',
          content: 'Welcome to your innovation intelligence dashboard.\nThis is where you can search for business across the globe, and create dashboards to research and track industry topics.',
        },
        {
          target: '.innovation-intelligence-overview-tour-step-1',
          content: 'This is global search, where you can search for businesses across the globe using a number of sources, which SimplyDo then enriches from other sources across the web.',
          disableBeacon: true,
        },
        {
          target: '.innovation-intelligence-overview-tour-step-2',
          content: 'Industry scout is where you can create dashboards to track industry topics, and research them in depth.',
          disableBeacon: true,
        },
        {
          target: '.innovation-intelligence-overview-tour-step-3',
          content: 'You can use lists to save groups of companies after finding them in searching, or to save companies you\'ve found in industry scout.',
          disableBeacon: true,
        },
      ],
    },
    {
      key: 'innovationIntelligenceSearch',
      value: 'innovationIntelligenceSearch',
      title: 'Innovation Intelligence (Search)',
      description: 'Give the user a brief tutorial in how to use the global search feature.',
      steps: [
        {
          placement: 'center',
          target: 'body',
          content: 'This is innovation intelligence global search.\nYou can use this to search for businesses across the globe using a number of sources, which SimplyDo then enriches from other sources across the web.',
        },
        {
          target: '.innovation-intelligence-search-tour-step-1',
          content: 'Begin by entering a search term into the search bar; You can also choose a primary source (Crunchbase, Companies House or CreditSafe) to search from, along with any relevant filters/sorts.',
          disableBeacon: true,
          customTourFunctionId: 'exampleSearch',
        },
      ],
    },
    {
      key: 'orgSwitcher',
      value: 'orgSwitcher',
      title: 'Navbar Organisation Switcher',
      description: 'Explain to users how to switch between organisations.',
      steps: [
        {
          target: '.org-switcher-tour-step-1',
          content: 'This is the organisation switcher.\nYou can use this to switch between organisations you are a member of, to see challenges and ideas in that organisation.',
          disableBeacon: true,
        }
      ],
    },
    {
      key: 'projectBoardOnIdeasPage',
      value: 'projectBoardOnIdeasPage',
      title: 'Project Board (Ideas Page)',
      description: 'Explain to users that the project board has moved into the challenge ideas page.',
      steps: [
        {
          target: '.project-board-ideas-page-1',
          content: 'The project board is now a subset of the ideas page. You can still access it by clicking the project board link in the sidebar, and you can change back to a different idea view by using this button',
          disableBeacon: true,
        },
      ],
    },
  ],

  accreditations: [
    { key: "cyberEssentialsPlus", text: "Cyber Essentials Plus" },
    { key: "cyberEssentials", text: "Cyber Essentials" },
    { key: "ISO27001", text: "ISO 27001" },
    { key: "ISO9001", text: "ISO 9001" },
    { key: "FENSA", text: "FENSA" },
    { key: "SSIP", text: "SSIP" },
    { key: "MCS", text: "MCS" },
    { key: "PAS2030", text: "PAS 2030" },
    { key: "livingWageEmployer", text: "Living Wage Employer" }
  ],
};

export default constants;
